import { render } from "./PaymentOrdersView.vue?vue&type=template&id=4d3c312c"
import script from "./PaymentOrdersView.vue?vue&type=script&lang=js"
export * from "./PaymentOrdersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__